module.exports = __webpack_public_path__ + "assets/webgl/card_109_EN_L0.f3dd9be2.jpg";